<failure-wrapper>
  <!-- Bank balances -->
  <bank-header />
  <!-- ! Bank balances -->

  <!--
    Dashboard. The wrapper exists so the notices card can share a grid with the package's
    blocks: `bfm-dashboard-finance` draws its own four-column grid, and the notices card
    is ours, outside it. Here the grid is the wrapper's and the package element only
    passes its children through — see `dashboard.component.scss`.
  -->
  <div class="dashboard__grid">
    <bfm-dashboard-finance
      [statistics]="statistics"
      [noTransitoryAccounts]="noTransitoryAccounts"
    />

    <info-card [notices]="infoNotices" />
  </div>
  <!-- ! Dashboard -->
</failure-wrapper>
